import { createSvgIcon } from '@mui/material';

export const ErrorCircleIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
    <path
      fill="currentColor"
      d="M10 14.167c.236 0 .434-.08.594-.24.16-.16.24-.358.24-.594a.806.806 0 0 0-.24-.593.806.806 0 0 0-.594-.24.806.806 0 0 0-.594.24.806.806 0 0 0-.24.593c0 .236.08.434.24.594.16.16.358.24.594.24Zm-.833-3.334h1.666v-5H9.167v5Zm.833 7.5a8.115 8.115 0 0 1-3.25-.656 8.416 8.416 0 0 1-2.646-1.781 8.415 8.415 0 0 1-1.781-2.646A8.115 8.115 0 0 1 1.667 10c0-1.153.218-2.236.656-3.25a8.415 8.415 0 0 1 1.781-2.646A8.415 8.415 0 0 1 6.75 2.323 8.115 8.115 0 0 1 10 1.667c1.153 0 2.236.218 3.25.656a8.415 8.415 0 0 1 2.646 1.781 8.416 8.416 0 0 1 1.781 2.646 8.115 8.115 0 0 1 .656 3.25 8.115 8.115 0 0 1-.656 3.25 8.415 8.415 0 0 1-1.781 2.646 8.415 8.415 0 0 1-2.646 1.781 8.115 8.115 0 0 1-3.25.656Z"
    />
  </svg>,
  'ErrorCircleIcon',
);
